import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'parcel-imports-dl-packet' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
